/** Allowed subscription SKUs for upgrade UI (env-driven; no external API). */
export const getAllowedSkus = (): string[] => {
  const multipleSkus = import.meta.env.VITE_APP_SKUS;
  if (multipleSkus) {
    return multipleSkus.split(',').map((sku: string) => sku.trim()).filter(Boolean);
  }
  const singleSku = import.meta.env.VITE_APP_SKU;
  return singleSku ? [singleSku] : [];
};
